module.exports = __webpack_public_path__ + "img/html-css.572f267a.png";